import React from 'react'

function privacy() {
  return (
    <div>
<section className="termslooper">
        <div className="container">
          <div className="p-8 max-w-4xl mx-auto text-gray-800">
            <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>

            <p className="mb-4">
              At Carig Photo Letter, we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and safeguard your information when you visit or use our website.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">1. Information We Collect</h2>
            <p className="mb-4">
              We may collect personal information such as your name, email address, contact number, and usage data when you register, subscribe to a newsletter, or interact with our services.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">2. How We Use Your Information</h2>
            <p className="mb-4">
              The information we collect is used to improve user experience, personalize content, respond to inquiries, send updates, and for analytics purposes.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">3. Cookies</h2>
            <p className="mb-4">
              We use cookies and similar tracking technologies to enhance your browsing experience. You can choose to disable cookies through your browser settings.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">4. Third-Party Services</h2>
            <p className="mb-4">
              We may use third-party tools (like Google Analytics) to understand our site traffic. These services may collect information under their own privacy policies.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">5. Data Security</h2>
            <p className="mb-4">
              We implement appropriate security measures to protect your data. However, no method of transmission over the internet is 100% secure.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">6. Changes to This Policy</h2>
            <p className="mb-4">
              We may update our privacy policy from time to time. We encourage you to review this page periodically for any changes.
            </p>

            <h2 className="text-xl font-semibold mt-6 mb-2">7. Contact Us</h2>
            <p>
              If you have any questions or concerns about this policy, please contact us at <a href="mailto:support@carigphotoletter.com" className="text-blue-600 underline">support@carigphotoletter.com</a>.
            </p>
          </div>
        </div>
      </section>
    </div>
  )
}

export default privacy
